<template>
  <Splide class="pb-14 laptop:pb-0" :has-track="false" :options="options" :aria-label="$t('our-newest-products')">
    <SplideTrack class="pt-8">
      <SplideSlide
        class="flex justify-center"
        v-for="eventIntercomm in props.events?.events?.data"
        :key="eventIntercomm.id || JSON.stringify(eventIntercomm)"
      >
        <ModalsEventsModalBtn
          :key="eventIntercomm.id || JSON.stringify(eventIntercomm)"
          :event="eventIntercomm"
          @open="(eventInfo) => emit('openEventModal', eventInfo)"
        />
      </SplideSlide>
    </SplideTrack>
    <div class="splide__arrows">
      <button class="splide__arrow--prev splide-arrow absolute !-left-[5em] top-[25%]">
        <svg width="80" height="23" viewBox="0 0 94 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 24H90.5L61 1" stroke="black" stroke-width="2" />
        </svg>
      </button>
      <button class="splide__arrow--next splide-arrow absolute !-right-[5em] top-[25%]">
        <svg width="80" height="23" viewBox="0 0 94 25" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0 24H90.5L61 1" stroke="black" stroke-width="2" />
        </svg>
      </button>
    </div>
  </Splide>
</template>
<script setup lang="ts">
import { Splide, SplideSlide, SplideTrack } from "@splidejs/vue-splide";
import { EventInformationFragment, GetEventsQuery } from "#gql";
import "@splidejs/vue-splide/css";
import { theme } from "#tailwind-config";
const props = defineProps<{
  events: GetEventsQuery | undefined | null;
}>();

const emit = defineEmits<{
  (event: "openEventModal", eventIntercomm: { event: EventInformationFragment; date: string }): void;
}>();
const { t: $t } = useI18n();

const laptop = theme?.screens?.laptop;
const tablet = theme?.screens?.tablet;

const laptopInt = parseInt(laptop.slice(0, -2));
const tabletInt = parseInt(tablet.slice(0, -2));

const options = {
  perPage: 5,
  pagination: false,
  gap: "1rem",
  padding: "4px",
  arrows: true,
  breakpoints: {
    [laptopInt]: { perPage: 3, arrows: false, pagination: true, padding: "5rem", gap: 0 },
    [tabletInt]: { perPage: 1, pagination: true, padding: "20%", gap: 0 },
  },
};
</script>
<style lang="scss" scoped>
:deep(.splide__pagination) {
  display: flex !important;
}
:deep(.splide-arrow) {
  transition: opacity 0.3s ease-out;
}

:deep(.splide__pagination__page) {
  background-color: #dfe1dd;
}
:deep(.splide__pagination__page.is-active) {
  background-color: #303030;
  transform: scale(1);
}
:deep(.splide-arrow) {
  &:disabled {
    opacity: 0;
  }
}
</style>
